import { Oauth2Principal } from '../../oauth2/oauth2.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Oauth2State {
  isAuthenticated: boolean | null;
  loading: boolean;
  principal: Oauth2Principal | null;
  error: string | null;
}

const initialState: Oauth2State = {
  isAuthenticated: null,
  loading: false,
  principal: null,
  error: null,
};

const oauth2Slice = createSlice({
  name: 'oauth2',
  initialState,
  reducers: {
    oauth2Request(state: Oauth2State) {
      state.loading = true;
      state.error = null;
    },
    oauth2Success(state: Oauth2State, action: PayloadAction<Oauth2Principal>) {
      state.isAuthenticated = true;
      state.loading = false;
      state.principal = action.payload;
    },
    oauth2Failure(state: Oauth2State, action: PayloadAction<string>) {
      state.isAuthenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    logout() {
      return { ...initialState };
    },
  },
});

export const { oauth2Request, oauth2Success, oauth2Failure, logout } = oauth2Slice.actions;
export default oauth2Slice.reducer;
